import {  DatePipe } from '@angular/common';
import { Component, Input, Self, Optional, EventEmitter, Output, ViewChild, HostListener, OnInit, forwardRef, OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { InputComponentType } from './InputComponentType';
import { NgxCurrencyConfig, NgxCurrencyInputMode } from 'ngx-currency';


@Component({
  selector: 'apc-form-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  host: { class: 'apc-form-input' }
})
export class InputComponent implements ControlValueAccessor,OnChanges {
  @Input() disabled: boolean;
  @Input() label: string;
  @Input() class: string;
  @Input() placeholder: string = '';
  @Input() type:InputComponentType = 'text';
  @Input() rows: string;
  @Input() onEdit: boolean = false;
  @Input() isCurrency: boolean = false;
  @Output() isChanged = new EventEmitter<any>();
  @Input() isEdit: boolean = false;
  public dateType: string = 'date';
  
  NgxCurrencyInputMode = NgxCurrencyInputMode;
  options:Partial<NgxCurrencyConfig> = { prefix:'', suffix: ' €', thousands: '.', decimal: ',', align: 'left', nullable: true, inputMode: NgxCurrencyInputMode.Natural }; 
  @ViewChild('t') t: NgbTooltip;
  @ViewChild('inputEl') inputEl;

  value: any = null;
  @Input() isRequired: boolean = false;

  constructor(@Self() @Optional() public ngControl: NgControl, private datePipe: DatePipe) {
    this.ngControl && (this.ngControl.valueAccessor = this);
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  @HostListener('click', ['$event'])
  onTripleClickOpenEdit(e) {
    if (e.detail === 3) {
      this.setInputTypeDate();
      if (e.target.type === 'text') {
        e.target.setSelectionRange(e.target.value.length, e.target.value.length + 1);
      }
    }
  }

  decimalWithComma(e) {
    if (this.type == 'number') {
      // if decimal number, round it
      if(e.target.value % 1 !== 0) {
      e.target.value = parseFloat(e.target.value).toFixed(1);
      }
      var k;
      document.all ? k = e.keyCode : k = e.which;
      return (k == 44 || (k >= 48 && k <= 57));
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
    if(changes.disabled){
      this.disabled = changes.disabled.currentValue;
    }
  }

  public onChangeFn = (_: any) => {};
  public onTouchedFn = () => {};

  public registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public writeValue(obj: any): void {
    this.value = obj;
  }

  onFocus() {
    if (!this.inputEl.nativeElement.closest('.editForm')) {
      this.isEdit = false;
    } else {
      this.isEdit = true;
    }
  }

  handleDateInputEdit() {
    if (!this.inputEl.nativeElement.closest('.editForm')) {
      this.dateType = 'date';
      this.isEdit = true;
    } else {
      this.dateType = 'text';
      this.isEdit = false;
    }
  }

  setInputTypeDate() {
    /*
    if(this.isEdit){
      this.dateType = 'date';
    }else{
      this.dateType = 'text';
    }*/
    this.dateType = 'date';
  }

  public onChange() {
    this.onChangeFn(this.value);
    this.isChanged.emit(this.value);
  }

  // work only with date input type
  clearDate() {
    this.value = null;
    this.onChangeFn(this.value);
  }

  showErrorTooltip() {
    this.t?.open();
  }

  get computedPlaceolder() {
    if (this.type !== 'date') {
      return this.placeholder;
    } else {
      if (this.value && this.value !== 'null' && this.value !== 'undefined') {
        return this.datePipe.transform(this.value, 'dd/MM/yyyy');
      } else if (this.onEdit) {
        return 'dd/mm/yyyy';
      } else {
        return this.placeholder;
      }
    }
  }
}
